import { render, staticRenderFns } from "./VrTable.vue?vue&type=template&id=62e0d015&scoped=true&"
import script from "./VrTable.vue?vue&type=script&lang=js&"
export * from "./VrTable.vue?vue&type=script&lang=js&"
import style0 from "./VrTable.vue?vue&type=style&index=0&id=62e0d015&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e0d015",
  null
  
)

export default component.exports